import {axios, HOST, config} from './settiing';

export default {

  getTermsList() {
    return axios.get(`${HOST}/manage/termsList`, config)
  },
  addTerms(data) {
    return axios.post(`${HOST}/manage/terms`, data, config);
  },
  getTermsContents(typeId) {
    return axios.get(`${HOST}/manage/terms/${typeId}`, config);
  },
  getTermsTitle(typeId) {
    return axios.get(`${HOST}/manage/termsTitle/${typeId}`, config)
  },

  /* TermsType */
  getTermsTypeList() {
    return axios.get(`${HOST}/manage/termsType`, config)
  },
  addTermsType(type, app) {
    return axios.get(`${HOST}/manage/termsType/${type}/${app}`, config);
  },
  updateTermsType(data) {
    return axios.put(`${HOST}/manage/termsType`, data, config)
  },
  deleteTermsType(id) {
    return axios.delete(`${HOST}/manage/termsType/${id}`, config);
  },
}